exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-confirmacao {\n  margin-right: 5px; }\n\n.modal-dialog {\n  min-width: 400px; }\n\n.modal-header {\n  background-color: #f7f7f7 !important;\n  padding-top: 11px !important;\n  padding-bottom: 11px !important; }\n\n.modal-footer {\n  text-align: left !important;\n  padding: 15px 30px !important;\n  border-top: 1px solid #f0f0f0;\n  display: block !important; }\n\n.modal-footer > .btn-link {\n  text-transform: none; }\n\n.modal-body {\n  font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/confirmacao/confirmacao.component.scss
// module id = ../../../../../src/app/angular-base-ui/confirmacao/confirmacao.component.scss
// module chunks = 1